/** Allowed view_source values — must match PHP intent_normalize_product_view_source(). */
export const PRODUCT_VIEW_SOURCES = {
  PDP: 'pdp',
  GRID: 'grid',
  SEARCH: 'search',
  GIFT_FINDER: 'gift_finder',
  HOME_SHELF: 'home_shelf',
  PDP_RELATED: 'pdp_related',
  PDP_BUNDLE: 'pdp_bundle',
  WISHLIST: 'wishlist',
  EXHIBITION: 'exhibition',
};

export const PRODUCT_VIEW_SOURCE_LABELS = {
  [PRODUCT_VIEW_SOURCES.PDP]: 'Product page',
  [PRODUCT_VIEW_SOURCES.GRID]: 'Shop grid',
  [PRODUCT_VIEW_SOURCES.SEARCH]: 'Search results',
  [PRODUCT_VIEW_SOURCES.GIFT_FINDER]: 'Gift finder',
  [PRODUCT_VIEW_SOURCES.HOME_SHELF]: 'Home shelf',
  [PRODUCT_VIEW_SOURCES.PDP_RELATED]: 'Related on PDP',
  [PRODUCT_VIEW_SOURCES.PDP_BUNDLE]: 'Bundle on PDP',
  [PRODUCT_VIEW_SOURCES.WISHLIST]: 'Wishlist',
  [PRODUCT_VIEW_SOURCES.EXHIBITION]: 'Exhibition RSVP',
};

export function formatProductViewSource(source) {
  const key = String(source || '').trim();
  if (!key) return '';
  return PRODUCT_VIEW_SOURCE_LABELS[key] || key.replace(/_/g, ' ');
}
